/* eslint-disable simple-import-sort/imports */
/* eslint-disable curly */
// This code is generated automatically. Do not modify it manually.
// The suppressions below are required to suppress false positive ESLint warnings.
//
// Generated: Wed, 20 May 2026 17:45:15 GMT
//
// noinspection RedundantIfStatementJS, JSUnusedGlobalSymbols, DuplicatedCode
//
import { Permission } from '@/types/permissions';

const valuesOfPermission: readonly string[] = [
  'ROLE_MANAGE_USER',
  'ROLE_CREATE_TRANSACTIONS',
  'ROLE_MANAGE_PAYMENT_CONTACTS',
  'ROLE_VIEW_ACTIVITY',
  'ROLE_RECEIVE_TRANSACTION_STATUS_NOTIFICATIONS',
  'ROLE_MANAGE_CUSTOMER',
  'ROLE_CREATE_USD_ACCOUNT',
  'ROLE_VIEW_USD_ACCOUNT',
  'ROLE_VIEW_BENEFICIARIES',
  'ROLE_WITHDRAW_INTEGRATOR_EARNINGS',
  'ROLE_MANAGE_INTEGRATOR_CREDENTIALS',
];

export const isPermission = (value: unknown): value is Permission => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfPermission.includes(value);
};

export const isPermissionOrNull = (value: unknown): value is Permission | null => {
  return value === null || isPermission(value);
};

export const isArrayOfPermission = (value: unknown): value is Permission[] => {
  return Array.isArray(value) && value.every(isPermission);
};

export const isArrayOfPermissionOrNull = (value: unknown): value is Permission[] | null => {
  return value === null || isArrayOfPermission(value);
};
